import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Semantik "warna = makna" (latar tipis + teks gelap, terbaca di HP kena matahari).
        // SLICE S-H/S-I (koreksi B2): SATU DEFINISI, SATU TEMPAT.
        // Nilai warna TIDAK ditulis di sini — setiap varian HANYA membaca token
        // semantik dari index.css (--badge-neutral/--badge-warning/dst). Token itu
        // sudah punya pasangan mode gelap sendiri (nilai berbeda di bawah .dark di
        // index.css), jadi kelas di bawah tidak perlu mengulang warna untuk dark:,
        // hanya boleh mengulang OPASITAS (bukan warna baru).
        neutral: "border-[hsl(var(--badge-neutral))]/40 bg-[hsl(var(--badge-neutral))]/10 text-[hsl(var(--badge-neutral))] dark:border-[hsl(var(--badge-neutral))]/25",
        warning: "border-[hsl(var(--badge-warning))]/40 bg-[hsl(var(--badge-warning))]/10 text-[hsl(var(--badge-warning))] dark:border-[hsl(var(--badge-warning))]/25",
        info: "border-[hsl(var(--badge-info))]/40 bg-[hsl(var(--badge-info))]/10 text-[hsl(var(--badge-info))] dark:border-[hsl(var(--badge-info))]/25",
        success: "border-[hsl(var(--badge-success))]/40 bg-[hsl(var(--badge-success))]/10 text-[hsl(var(--badge-success))] dark:border-[hsl(var(--badge-success))]/25",
        danger: "border-[hsl(var(--badge-danger))]/40 bg-[hsl(var(--badge-danger))]/10 text-[hsl(var(--badge-danger))] dark:border-[hsl(var(--badge-danger))]/25",
        // SLICE S-H/S-I (B1/B3): VIOLET = HANYA untuk FORCED (Force Bill), solid &
        // menonjol sebagai eskalasi. Warna dibaca dari --forced/--forced-foreground
        // (token yang sama dipakai di PiutangPage untuk tombol Force Bill).
        forced: "border-transparent bg-[hsl(var(--forced))] text-[hsl(var(--forced-foreground))] hover:bg-[hsl(var(--forced))]/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
